var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen  text-gray-800 bg-white ",class:_vm.marketingTheme + ' ' + _vm.marketingColor,attrs:{"id":"app"}},[_c('TopBanner'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }